import { render } from "./UserInviteView.vue?vue&type=template&id=5fb93459&scoped=true&ts=true"
import script from "./UserInviteView.vue?vue&type=script&lang=ts"
export * from "./UserInviteView.vue?vue&type=script&lang=ts"

import "./UserInviteView.vue?vue&type=style&index=0&id=5fb93459&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb93459"]])

export default __exports__